export default {
  main: {
    hero: `
        Nuestros juegos<br>
        son universos <strong>emocionantes</strong><br>
        llenos de personajes<br>
        <strong>encantadores</strong>
      `,
    homescapes: `Otra entrega épica de la serie Scapes™ donde hay que restaurar una mansión impresionante con Austin el mayordomo`,
    township: `Un fantástico juego de construcción con un montón de eventos, competiciones y torneos entre jugadores`,
  },
  common: {
    login: 'Iniciar sesión',
    logout: 'Cerrar sesión',
    support: 'Atención al cliente',
    privacy: 'Política de privacidad',
    terms: 'Condiciones de uso',
    and: 'y',
    guest: 'Invitado',
    play: 'Jugar',
    install: 'Instalar',
  },
  support: {
    title: '¿Necesitas ayuda?',
    description: `Si tienes algún problema con el juego,
      haremos todo lo posible por ayudarte y responder a todas tus preguntas.`,
    button: '@:common.support',
  },
  homescapes: {
    title: 'Homescapes',
    caption:
      'Ayuda a Austin el mayordomo a devolverle el calor y el confort a su maravillosa mansión familiar.',
    description: `Ayuda a Austin el mayordomo a devolverle el calor y el confort
      a su maravillosa mansión familiar. Adelante, ¡te esperan aventuras
      nada más cruzar el umbral!`,
    xsolla: 'Xsolla es distribuidor global autorizado de Homescapes',
    install: {
      title: '@:common.install',
      text: `¡Homescapes en tu ordenador!
      ¡Instala la versión web del juego y corre a ver a Austin con solo unos clics!`,
      button: '@:common.install',
    },
  },
  township: {
    title: 'Township',
    caption: `Construye la ciudad de tus sueños cosechando cultivos,
      procesándolos en las instalaciones
      y vendiendo productos para desarrollar tu ciudad.`,
    description: `Construye la ciudad de tus sueños cosechando cultivos,
      procesándolos en las instalaciones
      y vendiendo productos para desarrollar tu ciudad.`,
    xsolla: 'Xsolla es distribuidor global autorizado de Township',
    install: {
      title: '@:common.install',
      text: `¡Township en tu escritorio!
      Instala la versión web del juego y visita tu ciudad en solo un par de clics.`,
      button: '@:common.install',
    },
  },
  cookie: {
    message: 'Este sitio web utiliza cookies para proporcionarte la mejor experiencia posible.',
    link: 'Más información',
    button: 'Aceptar',
  },
  game: {
    notSupported: `No compatible con dispositivos móviles.
      Inicia sesión desde un ordenador para jugar.`,
  },
};
